import GlobalExportTracker from "./GlobalExportTracker";
import { RootState, useAppDispatch, useAppSelector } from "../../store/store";
import styles from "./index.module.css";
import { useSelector } from "react-redux";
import Logo from "../../assets/images/InceptionFinicallyLogo.png";
import profileImg from "../../assets/images/inceptionAdmin.jpeg";
import SliderOption from "./sliderOption";
import DashboardTiles from "./DashboardTiles";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import { yupResolver } from "@hookform/resolvers/yup";
import { cpaInfoSchema } from "../../yup";

import {
  useGetApaDataQuery,
  useGetDashboardDataQuery,
  useUpdateCpaMutation,
  useUploadLicenceMutation,
} from "../../services/api";
import Loader from "../Loader";
import { config } from "../../configs/index";
import useWindowResize from "../../hooks/useWindowResize";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";
import { setPurlUser } from "../../store/reducers/purlUserReducer";
import { AdvisorForm } from "../AdvisorForm";
import { BookkeeperForm } from "../BookkeeperForm";
import { CpaForm } from "../CpaForm";
import { FaEdit } from "react-icons/fa";
// import { hasRole } from "../../services/hasRole";
import { Roles } from "../../utils/role";
import useHasPermission from "../../hooks/useHasPermission";
import { tracker } from "../../services/mixpanel";
import { useSessionStorage } from "../../hooks/useSessionStorage";
import { trackScrollDepth } from "../../services/scrollTracker";
interface FieldValues {
  cpaName: string;
  cpaEmail: string;
  cpaPhone: string;
  profilePic?: string;
}

const PurlDashboard = () => {
  const { clear: clearSession } = useSessionStorage();
  const { hasPermission } = useHasPermission();
  const [addCpa, setAddCpa] = useState(false);
  const [addAdvisor, setAddAdvisor] = useState(false);
  const [addBookkeeper, setAddBookkeeper] = useState(false);

  const navigate = useNavigate();
  const token = localStorage.getItem("token") || "";
  const loginData = useSelector((state: RootState) => state.login);
  const purlUser = useAppSelector((state) => state.purlUser);
  const dispatch = useAppDispatch();

  const { data: dashboardData, isLoading: dashboardLoader } =
    useGetDashboardDataQuery(loginData?.zohoCustomerId);
  const [uploadLicence] = useUploadLicenceMutation();
  const { data: apaData, refetch: refetchApa } = useGetApaDataQuery({
    id: loginData.zohoCustomerId,
  });

  const contactOwner = { data: dashboardData?.data.contactOwner };

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FieldValues>({
    resolver: yupResolver(cpaInfoSchema),
  });
  const { width: screenWidth } = useWindowResize();

  const [previewUrl, setPreviewUrl] = useState("");
  const [fileId, setFileId] = useState("");
  const [showSidebar, setShowSidebar] = useState(false);
  const [loadingProfileImage, setLoadingProfileImage] = useState(false);

  const handleFileChange = async (files: FileList | null) => {
    if (files && files.length > 0) {
      const file = files[0];
      console.log("File selected:", file);
      const preview = URL.createObjectURL(file);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("contactId", loginData.zohoCustomerId);
      formData.append("type", "user");

      try {
        setLoadingProfileImage(true);
        const response: any = await uploadLicence(formData);
        if (response.data.data.code == "SUCCESS") {
          const id = response.data.data.details.id;
          setPreviewUrl(preview);
          setFileId(id);
          getImgUrl();
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        throw error;
      } finally {
        setLoadingProfileImage(false);
      }
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openLogoutConfirmModal = () => {
    tracker.dashboard.logout.openModal();
    setIsModalOpen(true);
  };

  const closeLogoutConfirmModal = () => {
    tracker.dashboard.logout.closeModal();
    setIsModalOpen(false);
  };

  const logout = () => {
    tracker.dashboard.logout.logout();
    localStorage.clear();
    clearSession();
    navigate(`/${purlUser.uniqueId}`);
    window.location.reload();
  };

  const setPurlUserReducer = (purlUser: IPurlUser) => {
    const purlData = {
      contactOwnerId: purlUser.Contact_Owner_ID,
      email: purlUser.Email,
      pinNew: purlUser.Pin_new,
      contactGroup: purlUser.Contact_Group,
      firstName: purlUser.First_Name,
      advisorName: purlUser.Advisor_Name,
      phone: purlUser.Phone,
      contactOwnerRole: purlUser.Contact_Owner_Role,
      bookkeeperPin: purlUser.Bookkeeper_Pin,
      contactOwnerZUID: purlUser.Contact_Owner_ZUID,
      creatorId: purlUser.CREATORID,
      solarStudyInvite: purlUser.Solar_Study_Invite,
      cpaEmail: purlUser.CPA_Email,
      advisorPin: purlUser.Advisor_Pin,
      advisorEmail: purlUser.Advisor_Email,
      advisorPhone: purlUser.Advisor_Phone,
      contactOwnerEmail: purlUser.Contact_Owner_Email,
      cpaPin: purlUser.CPA_Pin,
      solarStudyId: purlUser.Solar_Study_ID,
      contactOwnerPhone: purlUser.Contact_Owner_Phone,
      modifiedTime: purlUser.MODIFIEDTIME,
      bookkeeperName: purlUser.Bookkeeper_Name,
      bookkeeperEmail: purlUser.Bookkeeper_Email,
      cpaPhone: purlUser.CPA_Phone,
      pin: purlUser.Pin,
      contactOwner: purlUser.Contact_Owner,
      lastName: purlUser.Last_Name,
      uniqueId: purlUser.Unique_ID,
      crmContactId: purlUser.crm_Contact_ID,
      rowId: purlUser.ROWID,
      cpaName: purlUser.CPA_Name,
      entityName: purlUser.Entity_Name,
    };
    dispatch(setPurlUser(purlData));
  };

  const getName = () => {
    if (Roles.ADVISOR === loginData.role) return purlUser.advisorName;
    else if (Roles.BOOKKEEPER === loginData.role)
      return purlUser.bookkeeperName;
    else if (Roles.CPA === loginData.role) return purlUser.cpaName;
    else return loginData.firstName + " " + loginData.lastName;
  };

  const userName = getName();

  const uploadImageButton = () => {
    tracker.dashboard.others.uploadProfilePicture();
  };

  const handleAddCpa = (isUpdate = false) => {
    setAddCpa(true);
    tracker.dashboard.cpa.onClick(isUpdate);
  };

  const closeCpaModal = () => {
    setAddCpa(false);
    tracker.dashboard.cpa.closeModal();
  };

  const handleAddAdvisor = (isUpdate = false) => {
    setAddAdvisor(true);
    tracker.dashboard.advisor.onClick(isUpdate);
  };

  const closeAdvisorModal = () => {
    setAddAdvisor(false);
    tracker.dashboard.advisor.closeModal();
  };

  const handleAddBookkeeper = (isUpdate = false) => {
    setAddBookkeeper(true);
    tracker.dashboard.bookkeeper.onClick(isUpdate);
  };

  const closeBookkeeperModal = () => {
    setAddBookkeeper(false);
    tracker.dashboard.bookkeeper.closeModal();
  };

  const getImgUrl = async () => {
    try {
      setLoadingProfileImage(true);
      const response = await fetch(
        `${config.REACT_APP_BASE_URL}/api/user/user-img/${loginData.zohoCustomerId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            observe: "response",
            responseType: "blob",
          },
        }
      );

      if (response.status != 200) throw new Error("image not found");
      const arrayBuffer = await response.arrayBuffer();
      const blob = new Blob([arrayBuffer], {
        type: "application/octet-stream",
      });

      const url = window.URL.createObjectURL(blob);
      console.log(url, "URL");
      if (!url) return;
      setPreviewUrl(url);
    } catch (err: any) {
      console.log("error", err);
    } finally {
      setLoadingProfileImage(false);
    }
  };

  useEffect(() => {
    tracker.dashboard.others.dashboardViewed();
    getImgUrl();
  }, []);

  useEffect(() => {
    dashboardData?.data.zohoData &&
      setPurlUserReducer(dashboardData?.data.zohoData);
  }, [dashboardData]);

  useEffect(() => {
    // Track overall page scroll
    const cleanup = trackScrollDepth({
      name: "Homepage",
    });

    return cleanup; // Cleanup on component unmount
  }, []);

  if (dashboardLoader) {
    return (
      <div className="h-dvh w-full flex justify-center items-center">
        <Loader isLoading={true} size={24} />
      </div>
    );
  }

  return (
    <div className={`bg-white w-full flex ${styles.getClass}`}>
      {(screenWidth > 900 || showSidebar) && (
        <div className={`${showSidebar ? "w-full" : "w-[404px]"} bg-[#090F21]`}>
          {showSidebar ? (
            <Navbar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
          ) : (
            <div className="bg-[#303545] flex justify-center py-2 h-[10vh]">
              <img src={Logo} width={150} alt="logo" />
            </div>
          )}
          <div
            className={`${
              showSidebar ? "w-full" : "w-[345px]"
            } px-[2rem] mt-[6rem] mx-auto`}
          >
            <div className="bg-[#EFEFF42B] rounded-t-xl flex flex-col justify-center items-center p-3 pt-16 relative">
              <div className="absolute top-[-45%] w-[120px] h-[120px] overflow-hidden">
                {loadingProfileImage ? (
                  <div className="rounded-full h-[120px] w-[120px] object-cover bg-[#e4e4e4] flex items-center justify-center">
                    <Loader isLoading={true} size={33} />
                  </div>
                ) : (
                  <img
                    className="rounded-full h-full w-full object-cover"
                    width={120}
                    height={120}
                    src={previewUrl ? previewUrl : profileImg}
                    alt="img"
                  />
                )}

                <label
                  htmlFor="profileImage"
                  className="bg-green-500 cursor-pointer text-2xl flex items-center justify-center absolute w-[25px] h-[25px] bottom-2 right-2 text-white rounded-full"
                  onClick={uploadImageButton}
                >
                  +
                </label>
                <Controller
                  name="profilePic"
                  control={control}
                  render={({ field }) => (
                    <input
                      type="file"
                      id="profileImage"
                      className="rounded-full"
                      hidden
                      accept=".jpg,.jpeg,.png"
                      onChange={(e) => {
                        field.onChange(e.target.files);
                        handleFileChange(e.target.files);
                      }}
                    />
                  )}
                />
              </div>
              {/* <p className="font-semibold text-white text-[25px] text-center">
                {hasRole(loginData.role, "on-behalf")
                  ? `${userName} (${loginData.role})`
                  : userName}
              </p>
              {hasRole(loginData.role, "on-behalf") && (
                <p className="text-white font-thin">
                  On behalf of {loginData.firstName + " " + loginData.lastName}
                </p>
              )} */}
              <p className="font-semibold text-white text-[25px] text-center">
                {loginData.role !== "CUSTOMER"
                  ? `${userName} (${loginData.role})`
                  : userName}
              </p>
              {loginData.role !== "CUSTOMER" && (
                <p className="text-white font-thin">
                  On behalf of {loginData.firstName + " " + loginData.lastName}
                </p>
              )}
              <span className="text-white text-[21px]">
                {purlUser?.entityName || "-"}
              </span>
            </div>
            <div className="bg-[#EFEFF42B] py-8 px-8 rounded-b-xl">
              <div className="text-white">
                <p className="my-2 text-[17px] font-semibold">
                  Your Client Relations Team
                </p>
                <div className="flex flex-col mb-3">
                  <span className="text-[17px] font-semibold truncate">
                    {contactOwner?.data?.ownerName || (
                      <p className="text-center w-[200px] font-thin">-</p>
                    )}
                  </span>
                  <span className="text-[17px] truncate">
                    {contactOwner?.data?.ownerRole || (
                      <p className="text-center w-[200px] font-thin">-</p>
                    )}
                  </span>
                  <span className="text-[17px] truncate">
                    {contactOwner?.data?.ownerPhone}
                    {!contactOwner?.data?.ownerPhone && (
                      <p className="text-center w-[200px] font-thin">-</p>
                    )}
                  </span>
                  <span className="text-[17px]  truncate">
                    {contactOwner?.data?.ownerEmail || (
                      <p className="text-center w-[200px] font-thin">-</p>
                    )}
                  </span>
                </div>
                <div className="flex flex-col mb-3">
                  <span className="text-[17px] font-semibold w-full truncate">
                    {contactOwner?.data?.subOwnerName}
                    {!contactOwner?.data?.subOwnerName && (
                      <p className="text-center w-[200px] font-thin">-</p>
                    )}
                  </span>
                  <span className="text-[17px] truncate">
                    {contactOwner?.data?.subOwnerRole}
                    {!contactOwner?.data?.subOwnerRole && (
                      <p className="text-center w-[200px] font-thin">-</p>
                    )}
                  </span>

                  <span className="text-[17px] truncate">
                    {contactOwner?.data?.subOwnerPhone}
                    {!contactOwner?.data?.subOwnerPhone && (
                      <p className="text-center w-[200px] font-thin">-</p>
                    )}
                  </span>

                  <span className="text-[17px] truncate">
                    {contactOwner?.data?.subOwnerEmail}
                    {!contactOwner?.data?.subOwnerEmail && (
                      <p className="text-center w-[200px] font-thin">-</p>
                    )}
                  </span>
                </div>

                {/* CPA Section */}
                <div className="flex flex-col mb-3">
                  <div className="flex justify-between items-center">
                    {loginData.role !== "CUSTOMER" ? (
                      <span className="text-[17px] font-semibold">CPA</span>
                    ) : (
                      <span className="text-[17px] font-semibold">
                        Your CPA
                      </span>
                    )}
                    {/* {hasRole(loginData.role, "update:cpa") && */}
                    {/* {hasRole(loginData.role, "update:cpa") && */}
                    {hasPermission("updateCpa") && purlUser.cpaEmail && (
                      <FaEdit
                        onClick={() => handleAddCpa(true)}
                        className="cursor-pointer text-white hover:text-gray-300"
                        size={16}
                      />
                    )}
                  </div>
                  {dashboardLoader ? (
                    <Loader isLoading={true} size={20} />
                  ) : purlUser.cpaEmail ? (
                    <>
                      <span className="text-[17px] truncate">
                        {purlUser.cpaName || "-"}
                      </span>
                      <span className="text-[17px] truncate">
                        {purlUser.cpaPhone || "-"}
                      </span>
                      <span className="text-[17px] truncate">
                        {purlUser.cpaEmail || "-"}
                      </span>
                    </>
                  ) : (
                    // hasRole(loginData.role, "create:cpa") && (
                    hasPermission("createCpa") && (
                      <button
                        onClick={() => handleAddCpa(false)}
                        className="py-2 text-[17px] mt-2 bg-[#CFD8E4] rounded-sm text-black"
                      >
                        Add CPA
                      </button>
                    )
                  )}
                </div>

                {/* Advisor Section */}
                <div className="flex flex-col mb-3">
                  <div className="flex justify-between items-center">
                    {loginData.role !== "CUSTOMER" ? (
                      <span className="text-[17px] font-semibold">Advisor</span>
                    ) : (
                      <span className="text-[17px] font-semibold">
                        Your Advisor
                      </span>
                    )}
                    {/* {hasRole(loginData.role, "update:advisor") && */}
                    {hasPermission("updateAdvisor") &&
                      purlUser.advisorEmail && (
                        <FaEdit
                          onClick={() => handleAddAdvisor(true)}
                          className="cursor-pointer text-white hover:text-gray-300"
                          size={16}
                        />
                      )}
                  </div>
                  {dashboardLoader ? (
                    <Loader isLoading={dashboardLoader} size={20} />
                  ) : purlUser.advisorEmail ? (
                    <>
                      <span className="text-[17px] truncate">
                        {purlUser?.advisorName || "-"}
                      </span>
                      <span className="text-[17px] truncate">
                        {purlUser?.advisorPhone || "-"}
                      </span>
                      <span className="text-[17px] truncate">
                        {purlUser?.advisorEmail || "-"}
                      </span>
                    </>
                  ) : (
                    // hasRole(loginData.role, "create:advisor") && (
                    hasPermission("createAdvisor") && (
                      <button
                        onClick={() => handleAddAdvisor(false)}
                        className="py-2 text-[17px] mt-2 bg-[#CFD8E4] rounded-sm text-black"
                      >
                        Add Advisor
                      </button>
                    )
                  )}
                </div>

                {/* Bookkeeper Section */}
                <div className="flex flex-col mb-3">
                  <div className="flex justify-between items-center">
                    {loginData.role !== "CUSTOMER" ? (
                      <span className="text-[17px] font-semibold">
                        Bookkeeper
                      </span>
                    ) : (
                      <span className="text-[17px] font-semibold">
                        Your Bookkeeper
                      </span>
                    )}
                    {/* {hasRole(loginData.role, "update:bookkeeper") && */}
                    {hasPermission("updateBookkeeper") &&
                      purlUser?.bookkeeperEmail && (
                        <FaEdit
                          onClick={() => handleAddBookkeeper(true)}
                          className="cursor-pointer text-white hover:text-gray-300"
                          size={16}
                        />
                      )}
                  </div>
                  {dashboardLoader ? (
                    <Loader isLoading={dashboardLoader} size={20} />
                  ) : purlUser?.bookkeeperEmail ? (
                    <>
                      <span className="text-[17px] truncate">
                        {purlUser?.bookkeeperName || "-"}
                      </span>
                      <span className="text-[17px] truncate">
                        {purlUser?.bookkeeperEmail || "-"}
                      </span>
                    </>
                  ) : (
                    // hasRole(loginData.role, "create:bookkeeper") && (
                    hasPermission("createBookkeeper") && (
                      <button
                        onClick={() => handleAddBookkeeper(false)}
                        className="py-2 text-[17px] mt-2 bg-[#CFD8E4] rounded-sm text-black"
                      >
                        Add Bookkeeper
                      </button>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="my-8 text-center">
            <button
              onClick={() =>
                window.open("https://zfrmz.com/fHcCGLMIBcMb6nFQr4yc")
              }
              className="bg-[#CFD8E4] w-[281px] h-[43px] text-[17px]"
            >
              SHARE PORTAL FEEDBACK
            </button>
            <button
              onClick={openLogoutConfirmModal}
              className="bg-[#CFD8E4] w-[281px] h-[43px] text-[17px] m-[10px]"
            >
              LOGOUT
            </button>
          </div>
        </div>
      )}
      {!showSidebar && (
        <div className="w-full bg-[#EFEFF4]">
          {screenWidth < 900 && (
            <Navbar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
          )}
          <SliderOption apaData={apaData} />
          <DashboardTiles apaData={apaData} refetchApa={refetchApa} />
        </div>
      )}

      {/* Forms */}
      {addCpa && (
        <CpaForm
          isOpen={addCpa}
          onClose={closeCpaModal}
          initialValues={
            purlUser.cpaEmail
              ? {
                  cpaName: purlUser.cpaName || "",
                  cpaEmail: purlUser.cpaEmail || "",
                  cpaPhone: purlUser.cpaPhone || "",
                }
              : undefined
          }
        />
      )}

      {/* Advisor Form */}
      {addAdvisor && (
        <AdvisorForm
          isOpen={addAdvisor}
          onClose={closeAdvisorModal}
          initialValues={
            purlUser.advisorEmail
              ? {
                  advisorName: purlUser.advisorName || "",
                  advisorEmail: purlUser.advisorEmail || "",
                  advisorPhone: purlUser.advisorPhone || "",
                }
              : undefined
          }
        />
      )}

      {/* Bookkeeper Form */}
      {addBookkeeper && (
        <BookkeeperForm
          isOpen={addBookkeeper}
          onClose={closeBookkeeperModal}
          initialValues={
            purlUser.bookkeeperEmail
              ? {
                  bookkeeperName: purlUser.bookkeeperName || "",
                  bookkeeperEmail: purlUser.bookkeeperEmail || "",
                }
              : undefined
          }
        />
      )}

      <LogoutConfirmModal
        isOpen={isModalOpen}
        onClose={closeLogoutConfirmModal}
        onConfirm={() => {
          logout();
          closeLogoutConfirmModal();
        }}
      />
    </div>
  );
};

export default PurlDashboard;

const LogoutConfirmModal = ({ isOpen, onClose, onConfirm }: any) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10000]">
      <div className="bg-white w-[500px] p-6 py-8 rounded-lg shadow-lg">
        <h3 className="text-xl font-semibold mb-6">Are you sure to Logout?</h3>
        <div className="flex justify-end gap-3">
          <button
            onClick={onConfirm}
            className="bg-[#356C58] text-white px-4 py-2 rounded-lg font-[300]"
          >
            Confirm
          </button>
          <button
            onClick={onClose}
            className="bg-gray-300 text-black px-4 py-2 rounded-lg"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
